import Navbar from '../../components/header/navBar';
import Background from '../../components/backGround/backGround';
import { useNavigate } from 'react-router-dom';
import InputFieldDoc from '../../components/elements/inputFieldDoc';
import '../../common/styles/components/check.scss';
import { useEffect, useState } from 'react';
import { useFetchProfileMutate } from '../../common/services/sanitas/apiSanitasProfile';
import Loading from '../../components/elements/loading';

interface RegisterPageProps {}

const RegisterPage: React.FC<RegisterPageProps> = () => {
  const [statusX, setStatusX] = useState(false);
  const { mutate, isSuccess, error, data, isPending } = useFetchProfileMutate();

  const navigate = useNavigate();
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    statusX &&
      !isPending &&
      mutate({
        identityDocument: formJson.documentonumero as string,
        identityDocumentTypeId: Number(formJson.tipodedoc),
      });
  };
  const handleBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (isSuccess) {
      const payload = data;
      navigate('/quiero-registrarme/paso-1-verificacion', {
        state: { payload },
      });
    }
    if (error) {
      const errorMessage = error.message;
      navigate('/quiero-registrarme/error-registrar', {
        state: { error: errorMessage },
      });
    }
  }, [isSuccess, data, navigate, error]);

  return (
    <>
      <Navbar onlyLogo={true} />
      {isPending && <Loading />}
      <section className="info-h shrot">
        <div className="padding-global">
          <div className="padding-section-large">
            <div className="container-large">
              <div className="banner_grilla">
                <div
                  id="w-node-_4ad00283-b912-c4f1-f6b7-5dfad8616956-b995645b"
                  className="banner_form">
                  <div className="formulario w-form">
                    <form
                      onSubmit={handleSubmit}
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="post"
                      noValidate
                      className="form"
                      data-wf-page-id="6722689cb7d2c823b995645b"
                      data-wf-element-id="221eda68-b07c-d36b-9089-84cb7aded835">
                      <div className="title-component is-center">
                        <h2>Quiero registrarme</h2>
                        <div className="line-title"></div>
                      </div>
                      <div>Ingresa tu documento de identidad</div>
                      <div className="form_grid">
                        <InputFieldDoc setStatusX={setStatusX} />
                      </div>
                      <div className="form_textnota">
                       Recuerda que lo enviaremos al mail o celular que
                       tengas registrado con nosotros
                      </div>
                      <input
                        type="submit"
                        data-wait="Please wait..."
                        className="button is-full w-button"
                        value="Continuar"
                      />
                      <button
                        type="button"
                        onClick={handleBack}
                        className="button is-large outline is-full w-button">
                        Volver
                      </button>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="text-color-white text-size-small text-align-center txt-form">
                    RUC: 20523470761 · Razón Social: SANITAS PERU S.A. - EPS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Background />
    </>
  );
};

export default RegisterPage;
